import { useEffect, useState } from "react";
import { toast } from "sonner";
import { admin } from "../../lib/api";
import { panel, inputCls, btnPrimary, PageHead } from "../ui";
import { ChevronUp, ChevronDown, Eye, EyeOff } from "lucide-react";

const LABELS = {
  hero: "Hero Banner", marquee: "Marquee Strip", featured_products: "Featured Products",
  featured_collection: "Featured Collection", promo_banner: "Promo Banner", usp_strip: "USP Strip",
  editorial: "Editorial", newsletter: "Newsletter",
};
const EDITABLE = {
  hero: ["headline", "subtext", "image", "button_label", "button_link", "countdown"],
  featured_products: ["heading"],
  featured_collection: ["heading", "text", "image", "button_label", "button_link"],
  editorial: ["heading", "text", "image", "button_label", "button_link"],
  newsletter: ["heading", "text"],
};

export default function Homepage() {
  const [blocks, setBlocks] = useState([]);

  useEffect(() => { admin.get("/admin/homepage").then((r) => setBlocks(r.data)); }, []);

  const move = (i, dir) => {
    const j = i + dir; if (j < 0 || j >= blocks.length) return;
    const n = [...blocks]; [n[i], n[j]] = [n[j], n[i]]; setBlocks(n);
  };
  const toggle = (i) => setBlocks(blocks.map((b, idx) => idx === i ? { ...b, visible: !(b.visible !== false) } : b));
  const setCfg = (i, k, v) => setBlocks(blocks.map((b, idx) => idx === i ? { ...b, config: { ...b.config, [k]: v } } : b));

  const publish = async () => { await admin.put("/admin/homepage", blocks); toast.success("Homepage published — live now"); };

  return (
    <div>
      <PageHead title="Homepage Builder">
        <a href="/" target="_blank" rel="noreferrer" className="border border-zinc-700 px-4 py-2.5 text-xs font-bold uppercase tracking-wider text-zinc-200">Preview</a>
        <button onClick={publish} className={btnPrimary} data-testid="homepage-publish-btn">Publish</button>
      </PageHead>

      <div className="space-y-3">
        {blocks.map((b, i) => {
          const visible = b.visible !== false;
          const fields = EDITABLE[b.type] || [];
          return (
            <div key={b.id} className={`${panel} p-4`} data-testid={`block-${b.type}`}>
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <span className="text-[11px] text-zinc-600 w-6 text-center">{i + 1}</span>
                  <span className="text-sm font-semibold text-white">{LABELS[b.type] || b.type}</span>
                  {!visible && <span className="text-[10px] uppercase tracking-wider text-zinc-600 border border-zinc-800 px-1.5">Hidden</span>}
                </div>
                <div className="flex items-center gap-3">
                  <button onClick={() => toggle(i)} className="text-zinc-400 hover:text-white" title="Show/Hide">{visible ? <Eye size={16} /> : <EyeOff size={16} />}</button>
                  <button onClick={() => move(i, -1)} className="text-zinc-400 hover:text-white"><ChevronUp size={16} /></button>
                  <button onClick={() => move(i, 1)} className="text-zinc-400 hover:text-white"><ChevronDown size={16} /></button>
                </div>
              </div>
              {fields.length > 0 && (
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 mt-3 pt-3 border-t border-zinc-900">
                  {fields.map((f) => (
                    <input key={f} className={inputCls} placeholder={f.replace("_", " ")} value={b.config?.[f] || ""}
                      onChange={(e) => setCfg(i, f, e.target.value)} data-testid={`${b.type}-${f}`} />
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
